// extracted by mini-css-extract-plugin
export default {"patientList":"ParticipantList_patientList__IfUST"};